import { render, staticRenderFns } from "./ViewNewsButton.vue?vue&type=template&id=1d909f72&"
import script from "./ViewNewsButton.vue?vue&type=script&lang=js&"
export * from "./ViewNewsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports